import {
  useBoundingClientRect,
  useWindowResize,
} from '@moneyforward/ap-frontend-components';
import { useMemo, useRef } from 'react';

interface UseTableHeightProps {
  marginHeight?: number;
}

export const useTableHeight = ({ marginHeight = 100 }: UseTableHeightProps) => {
  const refContainer = useRef<HTMLDivElement>(null);
  const { innerHeight } = useWindowResize();
  const { top } = useBoundingClientRect(refContainer);

  const listHeight = useMemo(() => {
    if (top > 0) {
      return innerHeight - top - marginHeight;
    }
    return innerHeight - marginHeight;
  }, [innerHeight, top, marginHeight]);

  return { refContainer, listHeight };
};
